import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";

import {SimplePresentation, SimplePresentationRunner} from "./presentations/SimplePresentationRunner";
import {WinPresentation} from "./presentations/WinPresentation";
import {FreespinsOutroPresentation} from "./presentations/FreespinsOutroPresentation";
import {InfectiousXWaysPresentation} from "./presentations/InfectiousXWaysPresentation";
import {XWaysPresentation} from "./presentations/XWaysPresentation";
import {ExpandWildPresentation} from "./presentations/ExpandWildPresentation";
import {XActivatorPresentation} from "./presentations/XActivatorPresentation";
import {FreespinsScatterActivatePresentation} from "./presentations/FreespinsScatterActivatePresentation";
import {MysteryRevealPresentation} from "./presentations/MysteryRevealPresentation";
import {HideUIPresentation} from "./presentations/HideUIPresentation";
import {BrokeTheBankPresentation} from "./presentations/BrokeTheBankPresentation";
import {FullScreenSymbolPresentation} from "./presentations/FullScreenSymbolPresentation";
import {IndiSymWinPresentation} from "./presentations/IndiSymWinPresentation";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class PossessedWinPresentation implements FlowStatePresentation {

    private presentations:SimplePresentation[] = [
        //new RevealMysterySymbolsPresentation(),
        new ExpandWildPresentation(),
        new MysteryRevealPresentation(),
        new XWaysPresentation(),
        new InfectiousXWaysPresentation(),
        new FullScreenSymbolPresentation(),
        new IndiSymWinPresentation(),
        new WinPresentation(),

        new XActivatorPresentation(),
        new FreespinsScatterActivatePresentation(),
        new HideUIPresentation(),
        new FreespinsOutroPresentation(),
        new BrokeTheBankPresentation(),
    ]

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations,
                                     () => flowStateController.finish(),
                                     (callback?:Function) => flowStateController.setSkipCallback(callback),
                                     "WinRunner ");
    }
}